<template>
<!--  <pageComponents>-->
    <Card class="card">
      <div class="father">
        <div style="width: 400px; display: inline-block">
          <Input search enter-button="查询" v-model="searchValue" icon="ios-search" size='default' style="width: 400px" placeholder="请输入报名单位名称" class='topSearch' @on-click='searchFn' @on-search='searchFn'>
          </Input>
        </div>
        <Button class="exportExl" type="info" :loading="exportBut" @click="exportExl" v-if="isShow">导出数据</Button>
      </div>
      <div class="content">
        <Table size='small' class='activeList' ref="selection" border :loading='isLoading' highlight-row :columns="columns" :data="data" ></Table>
        <Page class="page" :total="totalCount" :currPage='currPage' :page-size-opts='pageSizeOpts' show-sizer show-elevator show-total transfer @on-change="pageChange" @on-page-size-change="pageSizeChange" :max-height="480"/>
        <!--<div class="holderImg" v-if="this.data.length < 3"></div>-->
      </div>
      <exportEx ref="exportEx" style="display: none"></exportEx>
    </Card>
<!--  </pageComponents>-->
</template>

<script>
import { handleRes } from '@/js/public'
import { Card, Input, Table, Page } from 'view-design'
import { mapState } from 'vuex'
import { orgSearch, orgSearchExport } from '@/api/getApi'
import exportEx from '@/components/common/exportEx'
import { info as msg } from '@/components/before/home/info'
export default {
  name: 'getOrgList',
  components: { Card, Input, Table, Page, exportEx },
  data () {
    return {
      msg: msg,
      exportBut: false,
      searchValue: '',
      isLoading: false,
      columns: [
        {
          title: '序号',
          type: 'index',
          width: 50,
          align: 'center'
        },
        {
          title: msg.school,
          key: 'school',
          align: 'center',
          render: (h, params) => {
            return <div domPropsInnerHTML={this.data[params.index].school}>
            </div>
          }
        },
        {
          title: msg.name,
          key: 'name',
          align: 'center',
          render: (h, params) => {
            const na = this.data[params.index].name
            const hiddenNa = na.substr(0, 1) + na.substr(1, na.length + 1).replace(/\S/g, '*')
            return <div domPropsInnerHTML={hiddenNa}>
            </div>
          }
        },
        {
          title: msg.mobile,
          key: 'mobile',
          align: 'center',
          render: (h, params) => {
            const phone = this.data[params.index].mobile
            const hiddenphone = phone.substr(0, 3) + '****' + phone.substr(7, 11)
            return <div domPropsInnerHTML={hiddenphone}>
            </div>
          }
        },
        {
          title: '报名状态',
          key: 'telephone',
          align: 'center',
          render: (h, params) => {
            return <div>
              报名成功
            </div>
          }
        }],
      data: [],
      pageSizeOpts: [10, 20, 50, 100],
      currPage: 1,
      totalCount: 1,
      page_size: 10
    }
  },
  computed: {
    isShow () {
      return this.$route.fullPath.includes('export')
    },
    ...mapState({
    })
  },
  methods: {
    pageChange (data) {
      this.currPage = data
      this.searchFn()
    },
    pageSizeChange (data) {
      this.table_size = data
      this.searchFn()
    },
    async exportExl () {
      this.exportBut = true
      const that = this
      const res = await orgSearchExport()
      const selfArr = []
      // const keys = []
      // const names = []
      const keys = [undefined, 'province', 'lib_type', 'school', 'name', 'department', 'telephone', 'mobile', 'position', 'email', 'created_at', 'is_rec', 'rec_count']
      const names = ['序号', '省份', '机构类型', '机构名称', '管理员姓名', '所属部门', '座机号码', '管理员手机号', '职务', '电子邮箱', '提交时间', '是否推荐', '推荐数']
      selfArr.push(names)
      res.data.forEach((val, ind) => {
        const item = []
        keys.forEach((ele, key) => {
          if (ele === undefined) {
            item.push(ind + 1)
          } else if (ele === 'lib_type') {
            item.push(`${val[ele]}` === '0' ? '公共图书馆' : '高校图书馆')
          } else if (ele === 'is_rec') {
            item.push(`${val[ele]}` === '0' ? '否' : '是')
          } else {
            item.push(val[ele])
          }
        })
        selfArr.push(item)
      })
      function exportExecl () {
        that.$refs.exportEx.arrToDownload(selfArr, '报名表')
        that.exportBut = false
      }
      exportExecl()
    },
    async searchFn () {
      if (!this.searchValue.trim() || !this.searchValue) {
        this.data = []
        return false
      }
      const params = {
        keyword: this.searchValue.trim(),
        page: this.currPage,
        page_size: this.table_size
      }
      const res = await orgSearch(params)
      handleRes(res, '', () => {
        this.data = res.data.data
        this.totalCount = res.data?.total ?? 1
        this.currPage = res.data?.current_page ?? 1
        this.page_size = Number(res.data?.per_page)
      }, '获取机构信息失败请稍候再试')
    }
  },
  beforeCreate () {
  },
  async created () {
  },
  mounted () {
  }
}
</script>

<style lang = 'scss' scoped>
@import '../../assets/scss/public.scss';
.card {
  position: relative;
  z-index: 999;
  width: 50%;
  min-width: 85rem;
  margin: 5rem auto;
  ::v-deep .ivu-card-body {
    padding: 0;
    min-height: 600px;
  }
  .father{
    padding: 16px;
    border-bottom: 1px solid #f2f2f2;
    text-align: left;
    .exportExl{
      vertical-align: top;
      margin-left: 10px;
    }
    ::v-deep .topSearchDiv{
      display: inline-block;
      vertical-align: middle;
    }
    .topSearch{
      /*display: inline-block;*/
    }
    ::v-deep .ivu-input-icon{
      margin-right: 0;
      right: 40px;
      color: #fff;
    }
    ::v-deep .ivu-input-group-append{
      width: 76px;
      text-align: right;
    }
  }
  .content{
    width: 100%;
    padding: 10px;
  }
  .page{
    margin: 10px;
    ::v-deep .ivu-page-options{
      input{
        vertical-align: top;
      }
    }
    text-align: center;
  }
  .holderImg{
    margin: 60px auto;
    height: 200px;
    width: 200px;
    @include bgimg-contain('../../assets/images/searchIcon.png')
  }
}
::v-deep .ivu-table-header thead tr th{
  border-right: 0;
  padding: 6px 0;
  font-size: 15px;
}
::v-deep ivu-table-tbody{
  font-size: 15px;
}
::v-deep .ivu-table-cell{
  padding-left: 10px;
  padding-right: 10px;
}
</style>
